module.exports = __webpack_public_path__ + "static/media/plus-circle.a44d7ff3.svg";